import React from "react";
import { Badge } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { AsyncTypeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { withNamespaces } from "react-i18next";
import axios from "axios";
import Postcode from "postcode";
import { osgb, wgs84 } from "./osgb";
import withinParkBoundary from "./BBNPAGeoTools";

const MAX_FEATURES = 20;

class GeoSearch extends React.Component {
  constructor(props) {
    super(props);

    this.onSelection = this.onSelection.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this.osgb = new osgb();
    this.wgs84 = new wgs84();

    this.state = {
      allowNew: false,
      isLoading: false,
      multiple: false,
      options: []
    };
  }
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <AsyncTypeahead
          {...this.state}
          minLength={2}
          useCache={false}
          onChange={this.onSelection}
          clearButton={true}
          onSearch={this._handleSearch}
          emptyLabel={t("search-no-matches")}
          placeholder={t("search-map")}
          filterBy={(option, props) => {
            return option;
          }}
          renderMenu={(results, menuProps) => (
            <Menu {...menuProps}>
              {results.map((result, index) => (
                <MenuItem key={index} option={result} position={index}>
                  {result.label}{" "}
                  <Badge className="float-right" color="secondary">
                    {result.type_name}
                  </Badge>
                </MenuItem>
              ))}
            </Menu>
          )}
        />
      </React.Fragment>
    );
  }

  onSelection(selection) {
    if (selection && selection.length > 0) {
      this.props.onSearchSelection({term: selection[0].label, location: selection[0].location});
    }else{
      this.props.onSearchSelection(null);
    }
    
  }

  _handleChange = e => {
    const { checked, name } = e.target;
    this.setState({ [name]: checked });
  };

  formatPostCode(postcode) {
    let pc = new Postcode(postcode);
    if (pc.valid()) {
      return pc.normalise();
    } else {
      return postcode;
    }
  }

  parseCoordinates(coords) {
    if (coords.indexOf(" ") !== -1) {
      let possibleCoords = coords.split(" ");
      if (
        possibleCoords.length === 2 &&
        !isNaN(parseFloat(possibleCoords[0])) &&
        !isNaN(parseFloat(possibleCoords[1]))
      ) {
        return [parseFloat(possibleCoords[0]), parseFloat(possibleCoords[1])];
      }
    }
    return false;
  }

  _handleSearch = query => {
    this.setState({ isLoading: true });

    var possibleItems = [];

    //Check if we have a valid british national grid item
    let osRes = this.osgb.parseGridRef(query.toUpperCase());
    if (osRes) {
      possibleItems.push({
        id: "999",
        label:
          query.toUpperCase() +
          " (E" +
          this.osgb.eastings +
          " N" +
          this.osgb.northings +
          ")",
        type_name: "British National Grid",
        location: [
          this.osgb.getWGS84().latitude,
          this.osgb.getWGS84().longitude
        ]
      });
    }
    let parsedCoords = this.parseCoordinates(query);
    //Check if we have a valid Eastings Northings
    if (parsedCoords) {
      this.osgb.setGridCoordinates(parsedCoords[0], parsedCoords[1]);
      if (
        !isNaN(this.osgb.getWGS84().latitude) &&
        !isNaN(this.osgb.getWGS84().longitude) &&
        withinParkBoundary(
          this.osgb.getWGS84().latitude,
          this.osgb.getWGS84().longitude
        )
      ) {
        possibleItems.push({
          id: "888",
          label: query,
          type_name: "Easting Northing",
          location: [
            this.osgb.getWGS84().latitude,
            this.osgb.getWGS84().longitude
          ]
        });
      }
    }

    //Check if we have a valid Lat lng
    if (parsedCoords) {
      if (
        withinParkBoundary(
          parsedCoords[0],
          parsedCoords[1]
        )
      ) {
        possibleItems.push({
          id: "888",
          label: query,
          type_name: "Lat Lng",
          location: [parsedCoords[0], parsedCoords[1]]
        });
      }
    }

    const params = {
      service: "WFS",
      request: "GetFeature",
      typeName: "bbnpa_external:bbnpa_gazetteer",
      version: "1.1.0",
      outputFormat: "json",
      maxFeatures: MAX_FEATURES
    };

    let scope = this;
    axios
      .get(
        "https://gis.beacons-npa.gov.uk/geoserver/ows?cql_filter=value ilike '" +
          query +
          "%25'",
        { params }
      )
      .then(function(response) {
        let gazeteerSearch = response.data.features.map(feature => {
          let value = feature.properties.value;
          if (feature.properties.value_type === "Post Code") {
            value = scope.formatPostCode(feature.properties.value);
          }
          scope.osgb.setGridCoordinates(
            feature.geometry.coordinates[0],
            feature.geometry.coordinates[1]
          );
          return {
            id: feature.properties.id,
            label: value,
            type_name: feature.properties.value_type,
            location: [
              scope.osgb.getWGS84().latitude,
              scope.osgb.getWGS84().longitude
            ]
          };
        });
        let allSearchResults = possibleItems.concat(gazeteerSearch);
        scope.setState({
          isLoading: false,
          options: allSearchResults
        });
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        scope.setState({
          isLoading: false
        });
      });
  };
}

export default withNamespaces()(GeoSearch);



// WEBPACK FOOTER //
// ./src/GeoSearch.jsx